// src/hooks/useScrollToTop.ts
import { useEffect, useRef, useCallback } from 'react';

interface UseScrollToTopOptions {
  threshold?: number;
  onScrollToTop: () => void;
  isLoading?: boolean;
  hasMore?: boolean;
}

export const useScrollToTop = ({
  threshold = 100,
  onScrollToTop,
  isLoading = false,
  hasMore = true
}: UseScrollToTopOptions) => {
  const scrollElementRef = useRef<HTMLDivElement>(null);
  const isLoadingRef = useRef(isLoading);
  
  useEffect(() => {
    isLoadingRef.current = isLoading;
  }, [isLoading]);

  const handleScroll = useCallback(() => {
    const element = scrollElementRef.current;
    if (!element) return;
    
    const scrollTop = element.scrollTop;
    const isNearTop = scrollTop <= threshold;
    
    if (isNearTop && !isLoadingRef.current && hasMore) {
      console.log('📍 Scroll detected: Loading older messages');
      onScrollToTop();
    }
  }, [threshold, onScrollToTop, hasMore]);

  useEffect(() => {
    const element = scrollElementRef.current;
    if (!element) return;

    element.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return scrollElementRef;
};